import React from 'react';

const TALLYGROUPS = [
  "Bank Accounts", "Bank OD A/c", "Branch / Divisions", "Capital Account", "Cash-in-Hand",
  "Current Assets", "Current Liabilities", "Deposits (Asset)", "Direct Expenses", "Direct Incomes",
  "Duties & Taxes", "Fixed Assets", "Indirect Expenses", "Indirect Incomes", "Investments",
  "Loans & Advances (Asset)", "Loans (Liability)", "Misc. Expenses (ASSET)", "Provisions",
  "Purchase Accounts", "Reserves & Surplus", "Retained Earnings", "Sales Accounts", "Secured Loans",
  "Stock-in-Hand", "Sundry Creditors", "Sundry Debtors", "Suspense A/c", "Unsecured Loans",
];

const LedgerForm = ({ mode, setmode, formdata, setformdata, saveledger }: any) => {
  if (mode != "editledger") return null;

  const options = [];
  for (let i = 0; i < TALLYGROUPS.length; i++) {
    options.push(<option key={TALLYGROUPS[i]} value={TALLYGROUPS[i]}>{TALLYGROUPS[i]}</option>);
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "Edit ledger" : "Add ledger"}</h3>
          <button className="close-btn" onClick={() => setmode(null)}>&times;</button>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); saveledger(); }}>
          <div className="fg">
            <label>Ledger name</label>
            <input
              type="text"
              value={formdata.ledgername}
              onChange={(e) => setformdata({ ...formdata, ledgername: e.target.value })}
              required
            />
          </div>
          <div className="fg">
            <label>Tally group</label>
            <select
              value={formdata.tallygroup}
              onChange={(e) => setformdata({ ...formdata, tallygroup: e.target.value })}
            >
              {options}
            </select>
          </div>
          <button type="submit" className="btn-primary full-width">Save</button>
        </form>
      </div>
    </div>
  );
};

export default LedgerForm;
